export const copaySupport = {
  "cutaquig": {
    name: 'SUPPORT FOR PATIENTS',
    title: "COPAY ASSISTANCE",
    description: "Eligible patients can receive up to a maximum of $12,500 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for Cutaquig.",
    copayInfo: {
      items: [
        { label: "Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need." },
        { label: "Cutaquig copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits." }
      ]
    },
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Cutaquig or have a prescription to begin treatment." },
        { label: "The patient must receive treatment with a Cutaquig National Drug Code (NDC)." },
        { label: "The patient must have commercial insurance." }
      ],
      note: "Note: Diagnosis codes are provided for reference only. Selection and documentation of an appropriate diagnosis code are the responsibility of the patient's health care provider."
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Cutaquig Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    },
    reimbursementSupport: {
      title: "REIMBURSEMENT SUPPORT",
      description: "If you have any questions about your insurance coverage please call the IgCares Support Center at 833-382-7686. We're here to help you navigate your coverage and provide support where needed.",
    },
    additionalResources: {
      title: "ADDITIONAL RESOURCES",
      description: "Please call the IgCares Program at 833-382-7686, or visit www.igcares.com for more information."
    }
  },
  "fibryga": {
    name: 'SUPPORT FOR PATIENTS',
    title: "COPAY ASSISTANCE",
    description: "Eligible patients can receive up to $2,500 per enrollment for copay assistance associated with the cost of Fibryga. Enrollment can be renewed at Octapharma's discretion up to 3 times within a calendar year.",
    copayInfo: {
      items: [
        { label: "Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need." },
        { label: "Fibryga copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits." }
      ]
    },
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Fibryga or have a prescription to begin treatment." },
        { label: "Patient must have commercial insurance" },
        { label: "Patient must use Fibryga® for the FDA-approved indication of treatment of acute bleeding episodes in adults and children with congenital fibrinogen deficiency, including afibrinogenemia and hypofibrinogenemia, with a diagnosis code of D68.2" }
      ],
      note: "Note: Diagnosis codes are provided for reference only. Selection and documentation of an appropriate diagnosis code are the responsibility of the patient's health care provider."
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    },
    reimbursementSupport: {
      title: "REIMBURSEMENT SUPPORT",
      description: "If you have any questions about your insurance coverage please call the Octapharma Support Center toll free at 1-800-554-4440. We're here to help you navigate your coverage and provide support where needed."
    }
  },
  "nuwiq": {
    name: 'COPAY AND REIMBURSEMENT ASSISTANCE FOR PATIENTS',
    title: "COPAY ASSISTANCE",
    description: "Eligible patients can receive up to a maximum of $12,000 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for NUWIQ®.",
    copayInfo: {
      items: [
        { label: "Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need." },
        { label: "NUWIQ® copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits." }
      ]
    },
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with NUWIQ® or have a prescription to begin treatment." },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    },
    reimbursementSupport: {
      title: "REIMBURSEMENT SUPPORT",
      description: "If you have any questions about your insurance coverage please call the Factor My Way Support Center at 855-498-4260. We're here to help you navigate your coverage and provide support where needed."
    },
    freeTrial: {
      title: "FREE TRIAL",
      description: "If you are currently using another FVIII product, or if you're not currently using factor treatment, you may want to consider NUWIQ.",
      items: [
        { label: "Eligible Hemophilia A patients can receive treatment with NUWIQ (not to exceed 6 doses or not exceed approximately 20,000 IUs) at no cost, shipped directly to you, and administered under the supervision and care of your physician." },
        { label: "Please call the Factor My Way Support Center at 855-498-4260 for more information." }
      ],
    }
  },
  "octagam": {
    name: 'SUPPORT FOR PATIENTS',
    title: "COPAY ASSISTANCE",
    description: "Eligible patients can receive up to a maximum of $12,500 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for Octagam 5% or Octagam 10%.",
    copayInfo: {
      items: [
        { label: "Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need." },
        { label: "Octagam 5% or Octagam 10% copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits." }
      ]
    },
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Octagam 5% or Octagam 10% or have a prescription to begin treatment." },
        { label: "The patient must receive treatment with a Octagam 5% or Octagam 10% National Drug Code (NDC)." },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    },
    reimbursementSupport: {
      title: "REIMBURSEMENT SUPPORT",
      description: "If you have any questions about your insurance coverage please call the Octapharma Support Center toll free at 800-554-4440. We're here to help you navigate your coverage and provide support where needed.",
    }
  },
  "panzyga": {
    name: 'SUPPORT FOR PATIENTS',
    title: "COPAY ASSISTANCE",
    description: "Eligible patients can receive up to a maximum of $12,500 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for PANZYGA.",
    copayInfo: {
      items: [
        { label: "Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need." },
        { label: "PANZYGA copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits." }
      ]
    },
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with Panzyga or have a prescription to begin treatment." },
        { label: "The patient must receive treatment with a Panzyga National Drug Code (NDC)." },
        { label: "The patient must have commercial insurance." }
      ],
      note: "Note: Diagnosis codes are provided for reference only. Selection and documentation of an appropriate diagnosis code are the responsibility of the patient's health care provider."
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    },
    reimbursementSupport: {
      title: "REIMBURSEMENT SUPPORT",
      description: "If you have any questions about your insurance coverage please call the Octapharma Support Center toll free at 800-554-4440. We're here to help you navigate your coverage and provide support where needed.",
      contactInfo: {
        name: "Octapharma Support Center",
        phone: "800-554-4440"
      }
    }
  },
  "wilate": {
    name: 'COPAY AND REIMBURSEMENT ASSISTANCE FOR PATIENTS',
    title: "COPAY ASSISTANCE",
    description: "Eligible patients can receive up to a maximum of $12,000 per calendar year of enrollment to cover the deductible, copay, and/or coinsurance for WILATE®.",
    copayInfo: {
      items: [
        { 
          label: "Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need.",
          link: {
            text: "Medmonk",
            url: "#"
          }
        },
        { label: "WILATE® copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits." }
      ]
    },
    eligibilityCriteria: {
      title: "ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE",
      items: [
        { label: "The patient must be receiving treatment with WILATE® or have a prescription to begin treatment." },
        { label: "The patient must have commercial insurance." }
      ]
    },
    restrictions: {
      title: "RESTRICTIONS",
      items: [
        { label: "Those with Medicare, Medicaid, Medigap, VA, DOD, Tricare or other federal or state government health insurance are not eligible." },
        { label: "The Copay Assistance Program does not cover costs associated with administration of therapy, such as office visits, infusion costs, or other professional services." }
      ]
    },
    reimbursementSupport: {
      title: "REIMBURSEMENT SUPPORT",
      description: "If you have any questions about your insurance coverage please call the Factor My Way Support Center at 855-498-4260. We're here to help you navigate your coverage and provide support where needed.",
    },
    freeTrial: {
      title: "FREE TRIAL",
      description: "If you are currently using another VWF/FVIII product, or if you're not currently using factor treatment, you may want to consider Wilate.",
      items: [
        { label: "Eligible VWD patients can receive treatment with WILATE® (not to exceed 1-3 doses or not exceed approximately 5,000 IUs) at no cost, shipped directly to you and administered under the supervision and care of your physician." },
        { label: "Please call the Factor My Way Support Center at 855-498-4260 for more information." }
      ]
    }
  },
};